import { Component, OnInit, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { BaseFormComponent } from '@classes/extends';
import { EvenementsCpService as EvenementsService } from '@estel-numerique/galaclick-api';
import { Constantes } from '@services/util/constantes';
import { DialogGalaComponent } from '../composants/dialog-gala/dialog-gala.component';
import { SelectGala } from '../composants/select/select.component';
import { MatButton } from '@angular/material/button';

@Component({
    templateUrl: './pilotageModal.html',
    imports: [DialogGalaComponent, FormsModule, ReactiveFormsModule, SelectGala, MatButton]
})
export class PilotageComponent extends BaseFormComponent implements OnInit {
    private eventCp = inject(EvenementsService);
    private formBuilder = inject(UntypedFormBuilder);
    private dialogRef = inject<MatDialogRef<PilotageComponent>>(MatDialogRef);

    public titre: string;
    public codeModule: string = Constantes.CodeOption.MPILOTAGE;// Code module/option testé pour vérifier l'accès à cette fonction (si null = OK)
    protected lgTrad: Record<string, string> = {};

    public formOptions: UntypedFormGroup;

    public listeOptions: { ID: number, LABEL: string }[] = [];

    constructor() {
        super();
        this.titre = this.translate.instant("APPFICHEANIMAL.TITRESEARCH");
        this.lgTrad = {
            ACTIONS: this.translate.instant("APPPILOTAGE.ACTIONS")
        };
        this.formOptions = this.formBuilder.group({
            ACTION: [null, [Validators.required]]
        });
        this.listeOptions = [
            { ID: 1, LABEL: this.translate.instant("APPPILOTAGE.PTOURNEES") }
        ];
    }

    public async lancerAction() {
        try {
            this.util.showLoader();
            if (this.validationFormulaire(this.formOptions) && this.formOptions.valid) {
                const idAction: number = this.formOptions.get("ACTION").value as number;
                switch (idAction) {
                    case 1: {
                        await this.eventCp.planifierEvenementsCp().toPromise();
                        break;
                    }
                }
                this.hideModal();
            }
        } catch (e) {
            this.util.fErreur(e);
        } finally {
            this.util.hideLoader();
        }
    }

    ngOnInit() {
        super.ngOnInit();
    }

    public hideModal() {
        this.dialogRef.close();
    }

}
